import { createContext, useContext } from 'react';

export function createStrictTableFiltersContext<TValue>(hookName: string) {
  const Context = createContext<TValue | null>(null);

  function useStrictTableFiltersContext(): TValue {
    const ctx = useContext(Context);
    if (!ctx) {
      throw new Error(`${hookName} must be used within its provider`);
    }
    return ctx;
  }

  return [Context, useStrictTableFiltersContext] as const;
}
